import React from 'react';
import { PlanChip } from '@/pages/Subscription/PlanChip';
import { PlanPrice } from '@/pages/Subscription/PlanPrice';
import type { PaymentOption } from '@/types/components';

interface Props {
  option: PaymentOption;
}

export const PlanSummaryCard: React.FC<Props> = ({ option }) => (
  <div className="flex h-full flex-col gap-2 rounded-xl bg-card p-4 shadow-card md:gap-4 md:rounded-2xl md:p-6">
    <div className="flex flex-row-reverse items-start justify-between gap-2 md:flex-col md:items-start md:gap-6">
      <PlanChip type={option.type} label={option.label} />
      <PlanPrice option={option} large />
    </div>
    <div className="flex flex-col md:gap-1">
      <p className="text-title-24 text-subtle-foreground">{option.title}</p>
      {option.subtitle && (
        <p className="text-body-14 text-subtle-foreground md:text-body-18">
          {option.subtitle}
        </p>
      )}
    </div>
  </div>
);
